import actionTypes from './actionTypes';

const innerInitialState = {
  isSubmitting: false,
  isSubmitted: false,
  isFailed: false,
  data: null,
  error: null,
};

export const innerReducer = (state = innerInitialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT: {
      return {
        ...state,
        ...innerInitialState,
        isSubmitting: true,
      };
    }

    case actionTypes.SUBMITTED: {
      return {
        ...state,
        data: action.payload.data,
        isSubmitting: false,
        isSubmitted: true,
        isFailed: false,
        errors: innerInitialState.errors || {},
        message: innerInitialState.message,
      };
    }

    case actionTypes.FAILED: {
      return {
        ...state,
        isSubmitting: false,
        isSubmitted: false,
        isFailed: true,
        error: action.payload.error,
      };
    }

    default:
      return state;
  }
};

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT:
    case actionTypes.SUBMITTED:
    case actionTypes.SUBMITTING:
    case actionTypes.FAILED:
      const { reducerName, ...restAction } = action;

      return {
        ...state,
        [reducerName]: innerReducer(state[reducerName], restAction),
      };

    case actionTypes.DESTROY: {
      return {
        [action.reducerName]: undefined,
      };
    }

    default:
      return state;
  }
};
